module.exports = __webpack_public_path__ + "static/img/20211206154059.aa9f606d.png";